export const spacing = {
  0: { value: '0px' },
  0.125: { value: '1px' },
  0.25: { value: '2px' },
  0.5: { value: '4px' },
  1: { value: '8px' },
  1.5: { value: '12px' },
  2: { value: '16px' },
  2.5: { value: '20px' },
  3: { value: '24px' },
  4: { value: '32px' },
  5: { value: '40px' },
  6: { value: '48px' },
  6.5: { value: '52px' },
  7: { value: '56px' },
  8: { value: '64px' },
  9: { value: '72px' },
  9.5: { value: '76px' },
  10: { value: '80px' },
  11: { value: '88px' },
  12: { value: '96px' },
  13: { value: '104px' },
  tightXS: { value: 'var(--spacing-tight-xs)' },
  tightS: { value: 'var(--spacing-tight-s)' },
  tightM: { value: 'var(--spacing-tight-m)' },
  tightL: { value: 'var(--spacing-tight-l)' },
  standardXS: { value: 'var(--spacing-standard-xs)' },
  standardS: { value: 'var(--spacing-standard-s)' },
  standardM: { value: 'var(--spacing-standard-m)' },
  standardL: { value: 'var(--spacing-standard-l)' },
  looseS: { value: 'var(--spacing-clearance-s)' },
  looseM: { value: 'var(--spacing-clearance-m)' },
  looseL: { value: 'var(--spacing-clearance-m-special)' },
} as const;

export const spacingVariables = {
  '--spacing-tight-xs': spacing['0.125'].value,
  '--spacing-tight-s': spacing['0.25'].value,
  '--spacing-tight-m': spacing['0.5'].value,
  '--spacing-tight-l': spacing['1'].value,
  '--spacing-standard-xs': spacing['1.5'].value,
  '--spacing-standard-s': spacing['2'].value,
  '--spacing-standard-m': spacing['3'].value,
  '--spacing-standard-l': spacing['4'].value,
  '--spacing-loose-s': spacing['6'].value,
  '--spacing-loose-m': spacing['7'].value,
  '--spacing-loose-l': spacing['7'].value,
};

export const spacingVariables4k = {
  '--spacing-tight-xs': spacing['0.25'].value,
  '--spacing-tight-s': spacing['0.5'].value,
  '--spacing-tight-m': spacing['1'].value,
  '--spacing-tight-l': spacing['1.5'].value,
  '--spacing-standard-xs': spacing['2'].value,
  '--spacing-standard-s': spacing['3'].value,
  '--spacing-standard-m': spacing['4'].value,
  '--spacing-standard-l': spacing['6'].value,
  '--spacing-loose-s': spacing['7'].value,
  '--spacing-loose-m': spacing['8'].value,
  '--spacing-loose-l': spacing['12'].value,
};
